import Mainboard from './Mainboard';

export default Mainboard;